import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

export default function PopUpBehaviorForm() {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        closePopupOnClickOutside: page.closePopupOnClickOutside || false,
      }}
      fields={({ values }) => [
        {
          type: 'checkbox',
          name: 'closePopupOnClickOutside',
          label: 'Allow visitors to close the pop-up by clicking outside it',
        },
      ]}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
    />
  );
}
